import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import {TweenLite, Power2} from 'gsap'

const TRANSITION_DURATION_SECONDS = 0.2;

class CircleSpinner extends PureComponent {

    _onEntering = (node) => {
        TweenLite.fromTo(node, TRANSITION_DURATION_SECONDS, {opacity: 0}, {opacity: 1, ease: Power2.easeInOut});
    }

    _onExiting = (node) => {
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {opacity: 0, ease: Power2.easeInOut } );
    }


    render() {
        const {classes, className, containerClassName, show} = this.props;

        return <TransitionGroup appear={true} enter={true} exit={true} className={containerClassName}>
            {show &&
            <Transition timeout={TRANSITION_DURATION_SECONDS*1000}
                        onEntering={this._onEntering}
                        onExiting={this._onExiting}>
                <svg className={cn(classes.spinner, className)} version="1.1" x="25px" y="25px" viewBox="0 0 50 50">
                    <path d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"></path>
              </svg>
            </Transition>}
        </TransitionGroup>
    }
}

export default injectSheet((theme) => (
    {
        spinner: {
            width: 32,
            height: 32,
            position: 'relative',
            fill: theme.colors.primary,
            animation: 'spin 0.6s infinite linear',
        },
        '@keyframes spin': {
            '0%': {
                transform: 'translate(-50%, -50%) rotate(0deg)'
            },
            '100%': {
                transform: 'translate(-50%, -50%) rotate(360deg)'
            }
        }
    }
))(CircleSpinner)





// WEBPACK FOOTER //
// ./src/components/Widgets/CircleSpinner.js